import { render, staticRenderFns } from "./Itinerarios.vue?vue&type=template&id=36fae841&lang=pug"
import script from "./Itinerarios.vue?vue&type=script&lang=js"
export * from "./Itinerarios.vue?vue&type=script&lang=js"
import style0 from "./Itinerarios.vue?vue&type=style&index=0&id=36fae841&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports